import * as React from "react";
import styled from "styled-components";
import { InfoCard } from "./InfoCard";
import { PageHeader } from "./PageHeader";

const cardData = [
  {
    title: "Sell Direct",
    content: `<span class="span-bold">Direct selling: a powerful retail channel used by global brands to market products directly to consumers.</span> Companies successfully market everything from jewelry and cookware to nutritionals and insurance.\n\nUnlike traditional retail, direct selling offers entrepreneurial opportunities with minimal startup costs.<span class="span-dark> Build your independent business with low overhead in a global industry worth $189.6B USD and growing.</span>`,
  },
  {
    title: "Our mission",
    content: `<span class="span-bold">B&B Global Solutions helps entrepreneurs launch successful Direct Sales or MLM businesses.</span> We transform traditional sales systems into powerful Direct Sales and Multi-Level Marketing networks <span class="span-bold">that eliminate middlemen and connect you directly with customers.</span>`,
  },
];

const formatTextWithCheckmarks = (text) => {
  const lines = text.split("<br />");
  return lines.map((line, index) => {
    const className = index % 2 === 0 ? "span-dark" : "span-bold";
    const extraSpace = (index + 1) % 3 === 0 ? <br /> : null;
    const checkmark = index % 3 === 0 ? "✅ " : "";
    return (
      <React.Fragment key={index}>
        <span className={className}>
          {checkmark}{line}
        </span>
        <br />
        {extraSpace}
      </React.Fragment>
    );
  });
};

export function AboutUs() {
  return (
    <PageContainer id="about">
      <ContentWrapper>
        <div>
          <PageHeader />
          <MainText>
            <span className="span-lg span-bold">
              Personalized service for maximum results.
            </span>
            <br />
            <br />
            {formatTextWithCheckmarks(`
              Work with our specialized team of industry experts.
              <br />Boost sales with our proven dynamic strategies.
              <br />Implement a market-focused sales model.
              <br />Get a customized system that fits your business.
              <br />Drive efficient growth with our solutions.
              <br />Specialists in direct and multi-level sales channels.
              <br />Eliminate middlemen and sell more effectively.
              <br />Global expertise across Europe, USA, Asia and Latin America.
              <br />Leadership team with extensive experience in major MLM companies.
            `)}
          </MainText>
        </div>
        <CardsContainer>
          {cardData.map((card, index) => (
            <InfoCard key={index} title={card.title} content={card.content} />
          ))}
        </CardsContainer>
      </ContentWrapper>
    </PageContainer>
  );
}

const PageContainer = styled.div`
  justify-content: center;
  align-items: center;
  background: var(--White, #fff);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-family: Manrope, sans-serif;
  padding: 110px 70px;
  position: relative;
  
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, rgba(240, 247, 255, 0.5), rgba(255, 255, 255, 0.8));
    z-index: -1;
  }
  
  &:after {
    content: '';
    position: absolute;
    bottom: -50px;
    right: -50px;
    width: 200px;
    height: 200px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(2, 73, 95, 0.1), transparent 70%);
    z-index: -1;
  }
  
  @media (max-width: 991px) {
    padding: 80px 20px;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 60px 75px;
  justify-content: center;
  flex-wrap: wrap;
  position: relative;
  
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const MainText = styled.div`
  color: var(--light-text);
  align-items: left;
  font-size: 16px;
  line-height: 28px;
  margin-top: 16px;
  max-width: 585px;
  position: relative;
  
  &:before {
    content: '';
    position: absolute;
    top: -30px;
    left: -30px;
    width: 60px;
    height: 60px;
    border-top: 4px solid rgba(2, 73, 95, 0.2);
    border-left: 4px solid rgba(2, 73, 95, 0.2);
    z-index: -1;
  }
  
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const CardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 580px;
  position: relative;
  
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;
